const examples = [
    {
      "title": "Carla Samantoes-Diego1",
      "subheader": "12.09.2021",
      "text": "SEEDRA Spinach Seeds - contains 600 seeds in 2 Packs and professional instructions created by PhD Helga George\nBe sure of our quality - the freshest batches of this season. Non-GMO, Heirloom - our seeds were tested and have the best germination ratings.",
      "imgPath": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRSV2qGtW8voE4pKShpZradtV9_xH9VLrjuzQ&usqp=CAU"
    },
    {
      "title": "Carla Samantoes-Diego2",
      "subheader": "12.09.2021",
      "text": "SEEDRA Spinach Seeds - contains 600 seeds in 2 Packs and professional instructions created by PhD Helga George\nBe sure of our quality - the freshest batches of this season. Non-GMO, Heirloom - our seeds were tested and have the best germination ratings.",
      "imgPath": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRIXYT2R4dLG1PWcGop3ZdhXdEOSPD5YSl-PAIwEZwLKyxVODm36hMRMhCHwWklYYlOw2A&usqp=CAU"
    },
    {
      "imgPath": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTkS8v2vSpIzK2HCPWDdfZP3vbvQhEm5fxuwkNENSNSswbBoWScLb0h3GjVFqgZB9FEpSg&usqp=CAU",
      "title": "Carla Samantoes-Diego3",
      "subheader": "12.09.2021",
      "text": "SEEDRA Spinach Seeds - contains 600 seeds in 2 Packs and professional instructions created by PhD Helga George\nBe sure of our quality - the freshest batches of this season. Non-GMO, Heirloom - our seeds were tested and have the best germination ratings."
    },
    {
      "title": "Carla Samantoes-Diego4",
      "subheader": "12.09.2021",
      "text": "SEEDRA Spinach Seeds - contains 600 seeds in 2 Packs and professional instructions created by PhD Helga George\nBe sure of our quality - the freshest batches of this season. Non-GMO, Heirloom - our seeds were tested and have the best germination ratings.",
      "imgPath": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQt5gua7odTECzGyOMnnw87E1YDLaDfaVo8oHU-mOXPUFVUyGm84Iu8skm8rTz5luW0Lg8&usqp=CAU"
    },
    {
      "title": "Carla Samantoes-Diego5",
      "subheader": "12.09.2021",
      "text": "SEEDRA Spinach Seeds - contains 600 seeds in 2 Packs and professional instructions created by PhD Helga George\nBe sure of our quality - the freshest batches of this season. Non-GMO, Heirloom - our seeds were tested and have the best germination ratings.",
      "imgPath": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTuNfh5XEmL28p3fZftINhCjPR1g7V8IDWJ9-H58s0jyp4GMH_nWaRqFrRFu-6CJbaTdK0&usqp=CAU"
    },
    {
      "title": "Carla Samantoes-Diego6",
      "subheader": "12.09.2021",
      "text": "SEEDRA Spinach Seeds - contains 600 seeds in 2 Packs and professional instructions created by PhD Helga George\nBe sure of our quality - the freshest batches of this season. Non-GMO, Heirloom - our seeds were tested and have the best germination ratings.",
      "imgPath": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ-6aKvbs_Afp97m1FhBKsAhp9cyG4ORzIFvHyqddNmqumvJ59Re3U8yvXM-gsJYu9HtGI&usqp=CAU"
    }
  ]
  
  export default examples